// extracted by mini-css-extract-plugin
export default {"container":"SurveyModal_container__23lvZ","header":"SurveyModal_header__0rGEy","footer":"SurveyModal_footer__aJNOH","link":"SurveyModal_link__gvdg5"};